import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Login } from './components/Login';
import { Home } from './components/Home';
import { AdminPage } from './components/Admin/AdminPage';
import { SubsetManagement } from './components/Admin/SubsetManagement';
import { WelcomeEditor } from './components/Admin/WelcomeEditor';
import { ProtectedRoute } from './components/ProtectedRoute';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Home />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <AdminPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/subsets"
          element={
            <ProtectedRoute>
              <SubsetManagement />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/welcome"
          element={
            <ProtectedRoute>
              <WelcomeEditor />
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
